var time = {};
/**
 * @description 获取时间段问候语
 */

time.timeGreetings = function () {
  // 获取当前时间
  var nowTime = new Date(); // 获取当前小时

  var hours = nowTime.getHours(); // 设置文字

  var text = ''; // 判断当前时间段

  if (hours < 6) text = '凌晨好';else if (hours < 9) text = '早上好';else if (hours < 12) text = '上午好';else if (hours < 14) text = '中午好';else if (hours < 17) text = '下午好';else if (hours < 19) text = '傍晚好';else if (hours < 22) text = '晚上好';else text = '深夜了';
  return text;
};

export default time;